module.exports = __webpack_public_path__ + "static/teleco_26-c56c567897ad478de7d052a9232e594a.jpg";